import React, { useState, useEffect } from "react";
import axios from "axios";
import "./blog.css";
import "./blog.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules"; 
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"; 

import img_blog_1 from '../../assets/blog_1.jpg'
import { TbCircleArrowUpRight } from "react-icons/tb";



const Blog = () => {
const [posts, setPosts] = useState([]);

   // fetch posts (videos)
  useEffect(() => {
    axios
      .get("https://admin.mythsegypttours.com/api/posts")
      .then((res) => setPosts(res.data))
      .catch((err) => console.error("Error fetching posts:", err));
  }, []);

  // fetch reviews (for tabs)
  useEffect(() => {
    axios
      .get("https://admin.mythsegypttours.com/api/reviews")
      .then((res) => setReviews(res.data))
      .catch((err) => console.error("Error fetching reviews:", err));
  }, []);

  const [activeTab, setActiveTab] = useState("All");
  const [reviews, setReviews] = useState([]);

  // tabs dynamic: All + كل الكاتيجوريز اللي ليها ريفيو
const categories = [...new Map(
  reviews
    .filter(r => r.trip?.category) // بس اللي ليها كاتيجوري
    .map(r => [r.trip.category.id, r.trip.category]) // unique by id
).values()];

const tabs = [
  { id: "All", label: "All Reviews" },
  ...categories.map(c => ({
    id: c.id,
    label: c.title,
    image: c.image
      ? c.image.startsWith("http")
        ? c.image
        : `https://admin.mythsegypttours.com/storage/${c.image}`
      : null
  }))
];


  useEffect(() => {
    axios.get("https://admin.mythsegypttours.com/api/reviews")
      .then((res) => {
        setReviews(res.data);
      })
      .catch((err) => {
        console.error("Error fetching reviews:", err);
      });
  }, []);
const displayedReviews =
  activeTab === "All"
    ? reviews
    : reviews.filter(r => r.trip?.category?.id === activeTab);

  return (
    <section className="main-blog container section">
      <div className="secTitle text-center mb-5">
        <span>Latest Blog & News</span>
        <h2 className="title">Latest News & Articles from the Blog Posts</h2>
        <p>
          We offer a variety of Egypt trips that allow you to experience the captivating Egyptian climate and marvel
          at the country’s stunning monuments. Our Egypt tours from the USA will take you to renowned sites like
          the Giza Pyramids, the Saqqara Necropolis, and the impressive Sphinx.
        </p>
      </div>

      {/* Blog static posts */}
      <div className="row blog__section blog-grid">
        {posts.map((post) => (
          <div key={post.id} className="blog-card style-5">
            <div className={`blog-image ${post.type === "big" ? "big-image" : "small-image"}`}>
              <video width="100%" controls>
  <source
    src={`https://admin.mythsegypttours.com/storage/${post.video}`}
    type="video/mp4"
  />
  Your browser does not support the video tag.
</video>


              <div className="blog-card-content">
                <div className="blog-card-content-top">
                  <ul>
                    <li>{post.date}</li>
                    <li>By {post.author}</li>
                  </ul>
                </div>

                <h5 className="post_title_h5">
                  <a href="#">{post.title}</a>
                </h5>

                <div className="bottom-area">
                  <a href="#">
                    View Post <TbCircleArrowUpRight className="arrowLink" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="tab-wrapper-blog">
        <ul className="travel-tab-blog">
          {tabs.map((tab) => (
            <li key={tab.id}>
              <button
                className={`travel-tab-btn-blog ${
                  activeTab === tab.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.image && <img src={tab.image} alt={tab.label} style={{width: "20px", marginRight: "8px"}} />}
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Reviews Slider */}
      <div className="blog-section blog-container">
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true, el: ".swiper-pagination" }}
          navigation={true}
          spaceBetween={20}
          slidesPerView={4}
          loop={true}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          
         {displayedReviews.map((review) => (
  <SwiperSlide key={review.id}>
    <div className="review-card">
                {/* Header */}
                <div className="review-header">
                 <img
  src={
    review.trip?.category?.image
      ? review.trip.category.image.startsWith("http")
        ? review.trip.category.image
        : `https://admin.mythsegypttours.com/storage/${review.trip.category.image}`
      : "https://via.placeholder.com/150"
  }
  alt={review.trip?.category?.title || "Category"}
  className="review-avatar"
/>
 <div className="review-info">
                    <h3 className="review-title">{review.trip?.title}</h3>
                    <span className="review-date">{review.reviewer_name}</span>
                    <br></br>
                    <span className="review-date">
                      {new Date(review.created_at).toLocaleDateString("en-GB")}
                    </span>
                  </div>
<img
  src={
    review.trip?.category?.image
      ? review.trip.category.image.startsWith("http")
        ? review.trip.category.image
        : `https://admin.mythsegypttours.com/storage/${review.trip.category.image}`
      : "https://via.placeholder.com/150"
  }
  alt={review.trip?.category?.title || "Category"}
  className="review-avatar-2"
/>

                </div>

                {/* Stars */}
                <div className="review-stars">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className="star"
                      style={{ color: i < review.stars ? "#FFD700" : "#ccc" }}
                    >
                      ★
                    </span>
                  ))}
                </div>

                {/* Comment */}
                <p className="review-text">{review.comment}</p>
              </div>
            </SwiperSlide>
          ))}

          <div className="swiper-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default Blog;
